import { Component, OnInit, ViewChild } from '@angular/core';
import { Column, GridOption, AngularGridInstance} from 'angular-slickgrid';
import { visitaBuqueDTO } from 'src/app/entidades/entidades.component';
import { VinsBuquesService } from 'src/app/servicios/vins-buques.service';
import { DateAdapter } from '@angular/material/core';
import { DatePipe } from '@angular/common';
import { AnalyticsService } from '../../servicios/analytics.service';
import { AveriasService } from '../../servicios/averias.service';
import { ChangeTabsService } from 'src/app/servicios/change-tabs.service';
import { SelectItem } from 'primeng/api';
//import { element } from 'protractor';
//import {SharedModule} from '../../shared/shared.module';
import { FormsModule } from '@angular/forms'; // Para [(ngModel)]
import { DropdownModule } from 'primeng/dropdown'; // Para <p-dropdown>
import { NbIconModule } from '@nebular/theme'; // Para <nb-icon>
import { CommonModule } from '@angular/common';
import { SpinnerComponent } from '../../spinner/spinner.component';
import { NbCardModule } from '@nebular/theme';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { AngularSlickgridModule } from 'angular-slickgrid';
import { NbTabsetModule } from '@nebular/theme';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core'; // necesario para el datepicker
import { NbSelectModule } from '@nebular/theme';
import { NbTreeGridModule } from '@nebular/theme';
import { MultiSelectModule } from 'primeng/multiselect';
import { MatIconModule } from '@angular/material/icon';

import { AgGridAngular } from 'ag-grid-angular'; // Angular Data Grid Component
import type { ColDef } from 'ag-grid-community'; // Column Definition Type Interface
import { GridApi, GridReadyEvent } from 'ag-grid-community';


@Component({
    selector: 'app-vins-buques-consulta',
    templateUrl: './vins-buques-consulta.component.html',
    styleUrls: ['./vins-buques-consulta.component.css'],
    standalone: true,
    imports: [FormsModule, MatIconModule, CommonModule, NbCardModule, NbIconModule, DropdownModule,
       MatCardModule, MatFormFieldModule, MatInputModule, AngularSlickgridModule,
        NbTabsetModule, MatDatepickerModule, MatNativeDateModule, NbSelectModule, 
        NbTreeGridModule, SpinnerComponent, MultiSelectModule,
      AgGridAngular],
    providers: [DatePipe],
})
export class VinsBuquesConsultaComponent implements OnInit {

  idCliente: number;
  buqueSelected;
  buques=[];
  procesoSelected;
  procesos;
  buqueSeleccionado;
  buquesVisita;
  buquesVisitaSeleccionado: visitaBuqueDTO = {
    idVisita: 0,
    idBuque:0,
    proceso: "",
    nombreBuque:"", 
    codVisitaExterno:"", 
    fechaArribo: null, 
    fechaPartida: null,
    etd: null,
    eta: null,
    ata: null,
    atd: null,
    idProceso : 0,
    codVerificacion: 0
  };
  showSpinner:boolean = false;
  angularGridVinsConsulta: AngularGridInstance;
  columnDefinitionsVinsConsulta: ColDef[];//Column[];
  gridOptionsVinsConsulta: GridOption;
  showGridModif:boolean = false;
  filtrado: number = 0;
  cantidadInspecciones: number = 0;  
  dataFiltered;
  datasetConsultas: any[] = [];
  cantidadVins: number = 0;
  deshabilitarProceso: boolean = true;
  deshabilitarBuscar: boolean = true;
  deshabilitarOperador: boolean = true;
  infoOperador;
  infoETA;
  infoETD;
  infoATA;
  infoATD;
  tabActivo;
  fechaCierre: string;
  estadoVisita: string;
  operadoresConsulta: SelectItem[];
  operadoresConsultaData: [];
  operadores = [];
  visitas;
  operadorSelected;
  operadorOptions;
  codVerificacion;

  @ViewChild('grilla1') grilla1!: AgGridAngular;
  @ViewChild('grilla2') grilla2!: AgGridAngular;
  @ViewChild('grilla3') grilla3!: AgGridAngular;


  constructor(private svcVinsBuq: VinsBuquesService, private adapter: DateAdapter<any>, 
    private dateFormatter: DatePipe, private changeVinsBuques: ChangeTabsService, 
    private svcAnalytics: AnalyticsService, private svcAverias: AveriasService ) { }

  ngOnInit(): void {
    this.idCliente = Number(localStorage.getItem('idCliente'))
    this.changeVinsBuques.tabVinsBuques.subscribe(data => {
      this.tabActivo = data;
      this.tabActivo == "Consultar" ? this.getBuquesVisita() : null;
    })
    this.adapter.setLocale('es-MX');
    this.getBuquesVisita();
    this.svcAnalytics.setAnalyticsPageView();
  }
  getBuquesVisita(){
    this.svcVinsBuq.getBuquesVisitaTodos(this.idCliente).subscribe(
      data => {
        this.buquesVisita = data;
        this.insertarBuquesVisita(this.buquesVisita);
      })
  }
  insertarBuquesVisita(arg) {
    this.buques = [];
    arg.forEach(element => {
      this.buques.push({
        Name: element.nombreBuque + " - " + element.codVisitaExterno,
        Codigo: element.codVisitaExterno + ";" + element.idBuque,
      });
    })
  }
  insertarProcesos(arg) {
    let procesos: Array<any> = [];
    arg.forEach(element => {
      procesos.push({
        Name: element.proceso,
        Codigo: element.idProceso,
      });
    })
    return procesos;
  }
  changeBuque(visitaExt) {
    
    this.buqueSeleccionado = null;
    this.operadorSelected = null;
    this.procesoSelected = null;
    this.deshabilitarOperador = true;
    this.deshabilitarProceso = true;
    this.deshabilitarBuscar = true;
    this.operadores = [];
    let idBuque = visitaExt.split(';')[1];
    let codigoDeVisita = visitaExt.split(';')[0];
  
    
    let buq = this.buquesVisita.find(n => n.codVisitaExterno == codigoDeVisita && n.idBuque == idBuque);
    this.buqueSeleccionado = buq;
    
    buq.operadores.forEach(op => {
      this.operadores.push({value: op.id, name:op.descripcion})
    });
  
    if(this.operadores.length == 1){
      this.operadorSelected = this.operadores[0];
      this.changeOperador();
    }
    this.reset();
    this.deshabilitarOperador = false;
    
  }
  
  changeOperador() {
    this.reset();
    this.procesoSelected = null;
    this.deshabilitarProceso = true;
    this.deshabilitarBuscar = true;

    let _proc = [];
    _proc = this.buqueSeleccionado.datosVisita.filter( element => element.idOperador == this.operadorSelected.value);
    this.visitas = _proc;

    this.procesos = this.insertarProcesos(_proc)
    this.deshabilitarProceso = false;
  }
  changeProceso(proceso){
    this.reset();
    this.buquesVisitaSeleccionado= this.visitas.find(n=> n.idProceso == proceso);
    this.deshabilitarBuscar = false;
  }
  formatoGrilla(){
    this.columnDefinitionsVinsConsulta = [
      { //id: 'vin', 
        headerName: 'VIN', field: 'vin', sortable: true, filter: true, floatingFilter: true, minWidth: 120, width: 120, },
      { //id: 'modelo', 
        headerName: 'Modelo', field: 'modelo', sortable: true, filter: true, floatingFilter: true, minWidth: 120, width: 120, },
      { //id: 'origen', 
        headerName: 'Origen', field: 'origen', sortable: true, filter: true, floatingFilter: true, minWidth: 120, width: 120, },
      { //id: 'destino', 
        headerName: 'Destino', field: 'destino', sortable: true, filter: true, floatingFilter: true, minWidth: 120, width: 120, },
      { //id: 'numeroFactura', 
        headerName: 'Factura', field: 'numeroFactura', sortable: true, filter: true, floatingFilter: true, minWidth: 60, width: 60, },
      { //id: 'bl', 
        headerName: 'BL', field: 'bl', sortable: true, filter: true, floatingFilter: true, minWidth: 60, width: 60, },
    ];
    this.gridOptionsVinsConsulta = {
      enableAutoResize: true,
      enableGridMenu: false,
      enableSorting: true,
      enableCellNavigation: true,
      enableCellMenu: true,
      enableCheckboxSelector: false,
      enableRowSelection: false,
      enableFiltering: true,
      enablePagination: false,
      rowSelectionOptions: { selectActiveRow: false }
    };
    this.showGridModif = true;
  }
  angularGridReady(angularGrid: AngularGridInstance) {
    this.angularGridVinsConsulta = angularGrid;
    this.angularGridVinsConsulta.resizerService.pauseResizer(false)
  }
  refreshMetrics(args) {
    if (args && args.current >= 0) {
      setTimeout(() => {
        this.dataFiltered = args.dataView.getFilteredItems();        
          if (this.cantidadInspecciones == args.current)
            this.filtrado = 0
          else
            this.filtrado = args.current       

      });
    }
  }
  buscarVisita(){
    this.showSpinner = true;
    this.datasetConsultas = [];
    this.showGridModif = false;
    this.svcVinsBuq.getDatosVisita(this.buquesVisitaSeleccionado.idVisita, this.buquesVisitaSeleccionado.idProceso)
    .subscribe(data => {
     for (let i = 0; i < data.vins.length; i++) {
        let _currVIN = data.vins[i];
        this.datasetConsultas.push({
          id: i,
          vin: _currVIN.vin,
          modelo: _currVIN.modelo,
          origen: _currVIN.origen,
          destino: _currVIN.destino,
          bl: _currVIN.bl,
          numeroFactura: _currVIN.numeroFactura,
        })
      }
      this.formatoGrilla();
      this.cantidadVins = data.vins.length
      this.infoOperador = data.operador
      this.infoETA = data.eta? this.formatearFecha(data.eta, 'dd/MM/yyyy') : "-";
      this.infoETD = data.etd? this.formatearFecha(data.etd, 'dd/MM/yyyy') : "-";
      this.infoATA = data.ata? this.formatearFecha(data.ata, 'dd/MM/yyyy') : "-";
      this.infoATD = data.atd? this.formatearFecha(data.atd, 'dd/MM/yyyy') : "-";
      this.fechaCierre = data.fechaCierre != ""? data.fechaCierre : "-";
      if(this.fechaCierre == null) this.estadoVisita = "Abierta";
      if(this.fechaCierre != null) this.estadoVisita = "Cerrada";
      this.showSpinner = false;
      this.showGridModif = true;
      this.codVerificacion = data.codVerificacion? data.codVerificacion : "-";
    })
    //gtag busqueda
    this.svcAnalytics.setAnalyticsSearchButton();
  }

  formatearFecha(fecha:any, formato:string ){
    fecha = this.dateFormatter.transform(new Date(fecha), formato);
    return fecha;
  }
  reset(){
    this.datasetConsultas = [];
    this.showGridModif = false;
    this.infoETA = "";
    this.infoETD = "";
    this.infoATA = "";
    this.infoATD = "";
    this.estadoVisita = "";
  }

    onGridReady(params: GridReadyEvent): void {
    this.grilla1.api.sizeColumnsToFit();
    this.grilla2.api.sizeColumnsToFit();
    this.grilla3.api.sizeColumnsToFit();
  
  }
  
}
